var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',[_c('img',{attrs:{"src":require("./../../../../public/images/apps/hifos-logo.png"),"alt":"John"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }